<template>
  <v-dialog
    v-model="showDialog"
    max-width="500px"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar
        dense
        flat
        :color="options.type"
      >
        <v-toolbar-title class="toolbar-title">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message">
        {{ message }}
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer />
        <v-btn
          v-if="!options.noconfirm"
          text
          @click.native="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          outlined
          @click.native="agree"
        >
          {{ options.confirmationText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  data() {
    return {
      showDialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        type: 'error',
        noconfirm: false,
        confirmationText: 'Ok'
      }
    }
  },

  methods: {
    open(title, message, options) {
      this.showDialog = true
      this.title = title
      this.message = message
      this.options = { ...this.options, ...options }
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.showDialog = false
    },
    cancel() {
      this.resolve(false)
      this.showDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
.toolbar-title {
  color: white
}
</style>
